/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, July 2023
 * @format
 * @flow
 */

import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  labels: {},
};

export const labelsSlice = createSlice({
  name: 'labels',
  initialState,
  reducers: {
    updateLabels: (state, action) => {
      state.labels = { ...state.labels, ...action.payload };
    }
  },
});

export const { updateLabels } = labelsSlice.actions;

export default labelsSlice.reducer;
